<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-chart-outline"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          IeA - Acompanhamento de Obras
        </div>
      </template>
      <div class="d-flex align-center justify-space-between flex-wrap my-5">
        <v-btn
          id="aie-novo-relatorio"
          color="success"
          elevation="1"
          text
          :to="{ name: 'AIE Adicionar' }"
        >
          <v-icon
            left
            size="30px"
          >
            mdi-plus-circle
          </v-icon>
          Novo Relatório
        </v-btn>
        <v-btn
          id="aie-nova-importacao"
          color="success"
          elevation="1"
          text
          :to="{ name: 'AIE Importar' }"
        >
          <v-icon
            left
            size="30px"
          >
            mdi-upload
          </v-icon>
          Nova Importação
        </v-btn>
        <v-btn
          id="aie-historico-justificativas"
          color="success"
          elevation="1"
          text
          :to="{ name: 'AIE Adicionar Histórico' }"
        >
          <v-icon
            left
            size="30px"
          >
            mdi-history
          </v-icon>
          Novo Histórico de Justificativas
        </v-btn>
      </div>
      <v-tabs
        v-model="tab"
        background-color="grey lighten-3"
        active-class="primary white--text"
        grow
        height="56"
        hide-slider
      >
        <v-tab>Consultas</v-tab>
        <v-tab>Importações de justificativas</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item><aie-consultas v-if="tab === 0" /></v-tab-item>
        <v-tab-item><aie-importacoes v-if="tab === 1" /></v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  name: 'AieHistorico',
  components: {
    AieConsultas: () => import('./Consultas.vue'),
    AieImportacoes: () => import('./Importacoes.vue')
  },
  computed: {
    tab: {
      get() {
        return this.$route.query.tab === 'importacoes' ? 1 : 0;
      },
      set(valor) {
        if (valor === this.tab) return;
        this.$router.replace({ query: { ...this.$route.query, tab: valor === 1 ? 'importacoes' : 'consultas' } });
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-slide-group__wrapper,
::v-deep .v-slide-group__content {
  width: 100%;
}
.v-tab {
  flex: 1 1 50%;
  max-width: none;
  min-height: 56px;
  font-weight: 500;
  white-space: normal;
}
</style>
